/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
import React from 'react'
import { TabHeader } from '../Header'
import { TabContent } from '../Content'

export class Tab extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			currentPage: 'similarAds'
		}
	}

	onTabClicked = page => {
		if (page !== this.state.currentPage) {
			this.setState({ currentPage: page })
		}
	}

	onImagesClosed = e => {
		this.setState({ currentPage: 'similarAds' })
	}

	render() {
		const { currentPage } = this.state
		return (
			<div className='oglasi-tab'>
				<TabHeader onClick={this.onTabClicked} currentPage={this.state.currentPage} />
				<TabContent page={currentPage} onImagesClosed={this.onImagesClosed} />
			</div>
		)
	}
}
